import {createSlice} from "@reduxjs/toolkit";
import api from "../helpers/api";
import _ from "lodash";

import Cookies from 'universal-cookie';
import * as Sentry from "@sentry/react";
import {$validate} from "../helpers/formValidator";

const cookies = new Cookies();


const authSlice = createSlice({
    name: 'auth',
    initialState: {
        access_token: null,
        password_strength: null,
        user: null,
        clinic: null,
        accountData: null,
        role: null,  //type of connected user. 2=clinic, 3=chain, 4=...,
        show_getting_started: false,
        has_new_changes: false,
    },
    reducers: {
        setAuthToken(state, action) {
            state.access_token = action.payload;
            // localStorage.setItem('access_token', action.payload.access_token);
            cookies.set('access_token', action.payload, {path: '/'});
        },

        setPasswordStrength(state, action) {
            state.password_strength = action.payload;
        },

        setUser(state, action) {
            state.user = action.payload;
            if(action.payload.seen_new_changes !== undefined) {
                state.has_new_changes = !action.payload.seen_new_changes;
            }
        },

        setClinic(state, action) {

            state.clinic = action.payload;
        },

        logout(state) {
            state.access_token = null;
            state.user = null;
            state.clinic = null;
            state.accountData = null;
            state.role = null;

            localStorage.removeItem('access_token');
            localStorage.removeItem('getting_started_last_user_id');
            cookies.set('access_token', '', {path: '/'});
        },

        acceptTerms(state) {
            state.user.terms = true;
        },
        setAccountData(state, action) {
            state.accountData = action.payload;
        },

        updateAccountData(state, action) {
            let accountData = {...state.accountData}

            if (action.payload) {
                _.forEach(action.payload, (v, k) => {
                    accountData[k] = v;
                })
            } else {
                accountData = null;
            }

            state.accountData = accountData;
        },

        changeLoadingStatus(state, action) {
            state.loading = action.payload;
        },

        setRole(state, action) {
            state.role = action.payload;
        },

        setShowGettingStarted(state, action) {
            state.user.show_getting_started = action.payload;
        },

        setHasNewChanges(state, action) {
            state.has_new_changes = action.payload;
        }
    }
});


export const login = (payload) => {
    return async (dispatch) => {
        try {
            let res = await api.post('auth/login', payload);

            if (res && res.success) {
                dispatch(authActions.setAuthToken(res.data.access_token))

                let errors = $validate(payload.password, ['password']);
                dispatch(authActions.setPasswordStrength(errors.length ? 0 : 1))
            }
            // console.log('login res', res)
            return res;
        } catch (e) {
            console.error('login error', e)
        }
    }
}

export const loginWithToken = (token) => {
    return async (dispatch) => {
        try {
            let res = await api.post('auth/login/token', {token: token});

            if (res && res.success) {
                dispatch(authActions.setAuthToken(res.data.access_token))
                // console.log('dispattch')
            }
            return res;
        } catch (e) {
            console.error('login error', e)
        }
    }
}

export const loginWithData = (data) => {
    return async (dispatch) => {
        try {
            // const token = data.access_token;
            // console.log(token)
            const user = {
                access_token: data.access_token,
                role: data.role,
                id: data.id,
                name: data.name,
                clinicName: data.clinic_name,
                terms_accepted: data.terms_accepted,
                show_getting_started: data.show_getting_started,
                seen_new_changes: data.seen_new_changes,
                active_notifications: data.active_notifications,
                logo: data.logo,
                notes: false,
            };

            dispatch(authActions.setAuthToken(data.access_token))
            dispatch(authActions.setUser(user))

            return user;
        } catch (e) {
            console.error('login error', e)
        }
    }
}

export const logout = (logoutAll = false) => {
    let url = logoutAll ? 'auth/logout/all' : 'auth/logout';

    return async (dispatch) => {
        try {
            let res = await api.post(url);
            Sentry.setTag('user_id', 'null');
            dispatch(authActions.logout());

            if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'local') {
                console.log('[!][REDIRECTION BLOCKED][2] env is local, user should be redirected to V2');
            } else {
                window.location = `${process.env.REACT_APP_FRONT_V2_URL}?logout=true`;
            }
            return res;
        } catch (e) {
            console.error('login error', e)
        }
    }
}

export const getUser = (force = false) => {
    return async (dispatch, getState) => {
        let state = getState().auth;
        if (state.user && !force) {
            return state.user;
        }

        let res = await api.get('account/user');
        // console.log(res)
        if (res.success) {
            dispatch(authActions.setUser(res.data.data))
            Sentry.setTag('user_id', res.data.data.id);
            return res.data.data;
        }
        return false;
    }
}

export const setPasswordStrength = (strength) => {
    return async (dispatch, getState) => {
        dispatch(authActions.setPasswordStrength(strength))
        return strength;
    }
}

export const getUserClinic = (force = false) => {
    return async (dispatch, getState) => {
        let state = getState().auth;
        if (state.clinic && !force) {
            return state.clinic;
        }

        if (state.user && state.user.role >= 4) {
            return null;
        }

        let res = await api.get('account/clinic');
        if (res.success) {
            dispatch(authActions.setClinic(res.data.data))
            Sentry.setTag('clinic_id', res.data.data.id);
            return res.data.data;
        }
        return false;
    }
}

// export const getUserType = () => {
//     return async (dispatch, getState) => {
//         let state = getState().auth;
//         if (state.role) {
//             return state.role;
//         }
//
//         try {
//             let res = await api.post('general/usertype');
//             if (res && res.data && res.data.data && res.data.data.user) {
//                 dispatch(authActions.setRole(res.data.data.user.role))
//                 return res.data.data.user;
//             }
//         } catch (e) {
//             console.error('error', e)
//         }
//         return state.accountData;
//     }
// }

export const acceptTerms = () => {
    return async (dispatch, getState) => {
        try {
            let res = await api.post('auth/terms/agree');
            if (res && res.data && res.data.data && res.data.data.user) {
                dispatch(authActions.acceptTerms())
                return true;
            }
        } catch (e) {
            console.error('error', e)
        }
        return false;
    }
}

export const setShowGettingStarted = (show) => {
    return async (dispatch, getState) => {
        try {
            let res = await api.post('auth/gettingstarted', {
                getting_started: show
            });
            if (res && res.data && res.data.data) {
                dispatch(authActions.setShowGettingStarted(show))
                return true;
            }
        } catch (e) {
            console.error('error', e)
        }

        return false;
    }
}

export const setHasNewChanges = (state) => {
    return async (dispatch, getState) => {
        dispatch(authActions.setHasNewChanges(state))
    }
}


// /**
//  * getting account data from server and storing in store state.
//  * if account data already exists, and no force command is passed from component, no call will be made.
//  * @param force
//  * @returns {(function(*, *): Promise<void>)|*}
//  */
// export const getAccountData = (force = false) => {
//     return async (dispatch, getState) => {
//         //checking if account data already exists. if exists and force is false, no need to get data from server;
//         let state = getState().auth;
//         if (state.accountData && !force) {
//             return state.accountData;
//         }
//
//         try {
//             let res = await api.get('account');
//             if (res && res.data && res.data.data) {
//                 dispatch(authActions.setAccountData(res.data.data))
//                 return res.data.data;
//             }
//         } catch (e) {
//             console.error('error', e)
//         }
//         return state.accountData;
//     }
// }

// /**
//  * function gets an object: accountData.
//  * account data can be null, whole object (as in state) or partial (only some fields)
//  * new fields will be updated in global state
//  * if input is null, account data will be updated to null which results in a new getAccountData call
//  *
//  * example: used in OpeningHours, TreatmentSettings
//  *
//  * @param data
//  * @returns {(function(*): Promise<void>)|*}
//  */
// export const updateAccountData = (data = null) => {
//     return async (dispatch) => {
//         dispatch(authActions.updateAccountData(data))
//     }
// }

export const authActions = authSlice.actions;
export default authSlice.reducer;
